import React, { createContext, useContext, useState } from 'react';

interface AudioContextType {
  audioActive: boolean;
  setAudioActive: (active: boolean) => void;
}

const AudioContext = createContext<AudioContextType>({
  audioActive: false,
  setAudioActive: () => {},
});

export const AudioProvider = ({ children }: { children: React.ReactNode }) => {
  const [audioActive, setAudioActive] = useState(false);
  return (
    <AudioContext.Provider value={{ audioActive, setAudioActive }}>
      {children}
    </AudioContext.Provider>
  );
};

export const useAudio = () => useContext(AudioContext);
